import type { ReactElement } from 'react';
import './LoaderVariant3.css';

export function LoaderVariant3(): ReactElement {
  return <div className="lv3" />;
}
